module.exports = __webpack_public_path__ + "static/img/event13.bdb9b67.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/event13.png
// module id = 6UM/
// module chunks = 1